import React from "react";
import { InlineMath } from "react-katex";
import FractionInput, { formatLatexPreview } from "../../../../components/inputs/FractionInput";

function randInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function formatMath1(v) {
  return Number(v).toFixed(1);
}

function pickStandardNoBorrow() {
  for (let i = 0; i < 600; i += 1) {
    const aUnits = randInt(10, 99);
    const bUnits = randInt(1, 89); // bez 0,0
    const aTenths = aUnits % 10;
    const bTenths = bUnits % 10;

    if (aTenths === 0 || bTenths === 0) continue; // bez x,0
    if (aUnits <= bUnits) continue;
    if (aTenths < bTenths) continue; // bez pożyczania w części dziesiętnej

    return {
      aUnits,
      bUnits,
      resultUnits: aUnits - bUnits,
      a: aUnits / 10,
      b: bUnits / 10,
      result: (aUnits - bUnits) / 10,
      mode: "standard",
    };
  }
  return null;
}

function pickFromIntegerBorrow() {
  for (let i = 0; i < 600; i += 1) {
    const aWhole = randInt(2, 9);
    const bWhole = randInt(0, aWhole - 1);
    const bTenths = randInt(1, 9);

    const aUnits = aWhole * 10; // liczba całkowita: x,0
    const bUnits = bWhole * 10 + bTenths;
    const resultUnits = aUnits - bUnits;

    if (resultUnits <= 0) continue;

    return {
      aUnits,
      bUnits,
      resultUnits,
      a: aUnits / 10,
      b: bUnits / 10,
      result: resultUnits / 10,
      mode: "fromInteger",
    };
  }
  return null;
}

function pickData() {
  // 50/50: zwykłe odejmowanie bez pożyczania w dziesiętnych
  // albo odejmowanie od liczby całkowitej (jedno pożyczenie z całości).
  const preferIntegerCase = Math.random() < 0.5;
  const first = preferIntegerCase ? pickFromIntegerBorrow() : pickStandardNoBorrow();
  if (first) return first;

  const second = preferIntegerCase ? pickStandardNoBorrow() : pickFromIntegerBorrow();
  if (second) return second;

  return {
    aUnits: 48,
    bUnits: 12,
    resultUnits: 36,
    a: 4.8,
    b: 1.2,
    result: 3.6,
    mode: "standard",
  };
}

export function generateTask() {
  return {
    type: "DecimalSubtractionMemoryNoBorrowTask",
    data: pickData(),
  };
}

export function renderTask({ data }) {
  return (
    <div style={{ textAlign: "left" }}>
      <p>Oblicz w pamięci: <InlineMath math={`${formatMath1(data.a)} - ${formatMath1(data.b)}`} /></p>
    </div>
  );
}

export function renderInput(_task, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
      label="wynik"
      placeholder="np. 3,2 lub 3.2"
    />
  );
}

export function checkAnswer(task, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;
  const parsed = userAnswer.parsed;
  if (parsed == null || !Number.isFinite(parsed)) return false;
  return Math.abs(parsed - task.data.result) < 1e-9;
}

export function renderAnswer({ data }) {
  return <InlineMath math={formatMath1(data.result).replace(".", "{,}")} />;
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }
  return <InlineMath math={formatLatexPreview(userAnswer.raw)} />;
}

export function renderExplanation({ data }) {
  const aWhole = Math.floor(data.aUnits / 10);
  const aTenths = data.aUnits % 10;
  const bWhole = Math.floor(data.bUnits / 10);
  const bTenths = data.bUnits % 10;

  if (data.mode === "fromInteger") {
    const tenthsBorrowed = 10;
    const tenths = tenthsBorrowed - bTenths;
    const whole = aWhole - 1 - bWhole;

    return (
      <div style={{ textAlign: "left" }}>
        <p>
          <strong>Krok 1:</strong> Odejmujemy od liczby całkowitej, więc pożyczamy 1 z całości:
          <InlineMath math={`${aWhole}{,}0\\to ${aWhole - 1}{,}10`} />.
        </p>
        <p>
          <strong>Krok 2:</strong> Dziesiętne: <InlineMath math={`${tenthsBorrowed}-${bTenths}=${tenths}`} />, a
          całości: <InlineMath math={`${aWhole}-1-${bWhole}=${whole}`} />.
        </p>
        <p>
          <strong>Wynik:</strong> <InlineMath math={`${whole}{,}${tenths}`} />.
        </p>
      </div>
    );
  }

  const tenths = aTenths - bTenths;
  const whole = aWhole - bWhole;

  return (
    <div style={{ textAlign: "left" }}>
      <p>
        <strong>Krok 1:</strong> Części dziesiętne: <InlineMath math={`${aTenths}-${bTenths}=${tenths}`} />.
      </p>
      <p>
        <strong>Krok 2:</strong> Całości: <InlineMath math={`${aWhole}-${bWhole}=${whole}`} />.
      </p>
      <p>
        <strong>Wynik:</strong> <InlineMath math={`${whole}{,}${tenths}`} />.
      </p>
    </div>
  );
}

